import React, { useState, useRef } from "react";
import useHandleclickOutside from "../../hooks/useHandleclickOutside";
import { useTheme } from "../../Components/BrandColors/Context/ThemeContext";

const Multiselect = ({ selectedProducts, setSelectedProducts, products }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const theme = useTheme() || "#3b82f6";

  useHandleclickOutside(dropdownRef, () => setIsDropdownOpen(false));

  const handleSelectProduct = (productId) => {
    if (!selectedProducts.includes(productId)) {
      setSelectedProducts([...selectedProducts, productId]);
    }
    setIsDropdownOpen(false);
    setSearchTerm(""); // Clear search term after selecting
  };

  const handleRemoveProduct = (productId) => {
    setSelectedProducts(selectedProducts.filter((item) => item !== productId));
  };

  const filteredProducts = products?.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="relative w-full" ref={dropdownRef}>
      <label htmlFor="products" className="block text-sm font-medium text-slate-700 mb-2">
        Select Products
      </label>
      
      <div
        className="w-full bg-blue-50 border border-blue-200/50 rounded-xl p-2 min-h-[50px] flex flex-wrap items-center gap-2 cursor-text focus-within:border-slate-500 transition-colors shadow-inner"
        onClick={() => setIsDropdownOpen(true)}
      >
        {selectedProducts.map((productId) => {
          const product = products?.find((p) => p._id === productId);
          return (
            <span 
              key={productId} 
              className="flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium text-white shadow-sm"
              style={{ backgroundColor: theme }}
            >
              {product?.name}
              <button
                type="button"
                className="w-4 h-4 rounded-full flex items-center justify-center bg-black/20 hover:bg-black/40 transition-colors focus:outline-none"
                onClick={(e) => {
                  e.stopPropagation();
                  handleRemoveProduct(productId);
                }}
              >
                &times;
              </button>
            </span>
          );
        })}
        <input
          id="products"
          type="text"
          className="flex-grow bg-transparent border-none outline-none text-slate-700 text-sm min-w-[120px] p-1"
          placeholder={selectedProducts.length === 0 ? "Search or select..." : ""}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => setIsDropdownOpen(true)}
        />
      </div>

      {isDropdownOpen && (
        <div className="absolute z-50 w-full mt-2 bg-white border border-blue-200/50 rounded-xl shadow-2xl overflow-hidden backdrop-blur-md animate-fade-in-up">
          <div className="max-h-60 overflow-y-auto scrollbar-hide">
            {filteredProducts?.length > 0 ? (
              filteredProducts.map((product) => {
                const isSelected = selectedProducts.includes(product._id);
                return (
                  <div
                    key={product._id}
                    className={`px-4 py-3 cursor-pointer text-sm transition-colors
                      ${isSelected ? 'bg-blue-100/50 text-slate-600' : 'text-slate-700 hover:bg-blue-100 hover:text-white'}
                    `}
                    onClick={() => !isSelected && handleSelectProduct(product._id)}
                  >
                    {product.name}
                    {isSelected && (
                      <span className="float-right text-xs" style={{ color: theme }}>Selected</span>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="px-4 py-3 text-sm text-slate-500 text-center">No results found</div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Multiselect;
